import { useMutation } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { DELETE_ARTICLE_CATEGORY_MUTATION } from './deleteArticleCategory.mutation';
import {
  DeleteArticleCategoryMutation,
  DeleteArticleCategoryMutationVariables
} from './__generated__/DeleteArticleCategoryMutation';

export const useDeleteArticleCategory = () => {
  return useMutation<DeleteArticleCategoryMutation, DeleteArticleCategoryMutationVariables>(
    DELETE_ARTICLE_CATEGORY_MUTATION,
    { client: kmsClient }
  );
};
